import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const DropdownSkeleton = () => {
    return (
        <Skeleton width={'100%'} height={'40px'} />
    )
}

export default DropdownSkeleton